// extracted by mini-css-extract-plugin
export default {"roseRound":"rounds_roseRound__LCkAz","yellowRound":"rounds_yellowRound__shILJ"};